// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export default {
  Alert: {
    close: 'Close'
  },
  Card: {
    select: 'Valitse',
    titleLinkTooltip: 'Siirry sivulle',
    collapseCardTooltip: 'Sulje kortti',
    expandCardTooltip: 'Laajenna kortti'
  },
  CardList: {
    loadMore: 'Lataa lisää',
    notFound: 'Kohteita ei löytynyt.',
    toolbarSelect: 'Valitse',
    viewCards: 'Kortit',
    viewTiles: 'Ruudut',
    viewList: 'Luettelo',
    toolbarView: 'Näytä'
  },
  Carousel: {
    nextSlide: 'Next slide',
    previousSlide: 'Previous slide',
    viewSlide: 'View slide %%slideNumber%%'
  },
  ComboBox: {
    close: 'Close',
    open: 'Open'
  },
  ClosingConfirmation: {
    confirm: 'Poistu',
    cancel: 'Palaa takaisin',
    content: 'Haluatko varmasti sulkea ja poistua tästä ikkunasta? Tekemiäsi tietomuutoksia ei tallenneta.'
  },
  Cuttable: {
    showMore: 'Näytä enemmän',
    showLess: 'Näytä vähemmän'
  },
  Dialog: {
    closeButton: 'Close',
    cancelButton: 'Peruuta'
  },
  Drawer: {
    backButton: 'Back',
    closeButton: 'Close',
    hideButton: 'Hide'
  },
  DrawerProgress: {
    cancelButton: 'Peruuta'
  },
  Dropdown: {
    close: 'Sulje'
  },
  Form: {
    submitButton: 'Tallenna',
    applyButton: 'Hyväksy',
    cancelButton: 'Peruuta'
  },
  FormField: {
    clear: 'Tyhjennä',
    remove: 'Poista',
    addMore: 'Lisää vielä yksi',
    showDescription: 'Show description'
  },
  FormFieldPassword: {
    improvePassword: 'Näin parannat salasanaasi:',
    passwordTooShort: 'Tee salasanasta pitempi.',
    lettersLowerCase: 'Käytä vähintään yhtä pientä kirjainta.',
    lettersUpperCase: 'Käytä vähintään yhtä isoa kirjainta.',
    numbers1: 'Käytä vähintään yhtä numeroa.',
    numbers3: 'Käytä vähintään kolmea numeroa.',
    specialChar1: 'Käytä vähintään yhtä erikoismerkkiä (esim. !, @, #, $, %, ^, &, *, ?, _, ~).',
    specialChar2: 'Käytä vähintään kahta erikoismerkkiä (esim. !, @, #, $, %, ^, &, *, ?, _, ~).',
    comboUpperAndLower: 'Käytä sekä isoja että pieniä kirjaimia.',
    comboLettersAndNumbers: 'Käytä sekä numeroita että kirjaimia.',
    comboLettersNumbersSpecial: 'Käytä numeroita, kirjaimia ja erikoismerkkejä.',
    yourPasswordIsStrong: 'Voit tehdä siitä vielä vahvemman lisäämällä sen pituutta.',
    passwordStrength: 'Salasanan vahvuus on %%strength%%.',
    strengthVeryStrong: 'HYVIN VAHVA',
    strengthStrong: 'VAHVA',
    strengthVeryWeak: 'HYVIN HEIKKO',
    strengthWeak: 'HEIKKO',
    strengthMedium: 'KOHTALAINEN',
    hidePassword: 'Piilota salasana',
    showPassword: 'Näytä salasana',
    generateButton: 'Luo',
    copyButtonHint: 'Kopioi salasana',
    copySuccessToast: 'Salasana kopioitiin',
    generateButtonHint: 'Luo vahva salasana'
  },
  InPlaceEdit: {
    cancelButtonHint: 'Hylkää muutokset',
    editButtonHint: 'Muokkaa arvoa',
    okButtonHint: 'Tallenna muutokset'
  },
  InputNumber: {
    decrement: 'Decrement',
    increment: 'Increment'
  },
  InputFile: {
    browseButton: 'Valitse tiedosto...'
  },
  Layout: {
    openSidebar: 'Expand sidebar',
    closeSidebar: 'Collapse sidebar'
  },
  List: {
    totalRows: 'Yhteensä %%totalRows%% kohdetta',
    toggleAllRows: 'Toggle all rows',
    toggleRow: 'Toggle row',
    selectedRows: '%%totalRows%% kohteesta %%selectedRows%% valittu',
    all: 'kaikki',
    allItemsOnPageSelected: 'Kaikki kohteet valittu sivulla',
    allItemsSelected: 'Kaikki kohteet valittu',
    selectAllItems: 'Valitse kaikki kohteet',
    selectAllItemsOnPage: 'Valitse kaikki kohteet sivulla',
    deselectAll: 'Poista valinta',
    selectRow: 'Select row',
    selectAllRows: 'Select all rows'
  },
  ListActions: {
    menuButton: 'Open menu'
  },
  ListEmptyView: {
    filteredTitle: 'Suodattimella ei löytynyt kohteita',
    emptyTitle: 'Täällä ei näytä olevan mitään',
    filteredDescription: 'Muokkaa hakua tai poista osa suodattimen kriteereistä ja yritä uudelleen.'
  },
  ListOperation: {
    cancelButton: 'Peruuta'
  },
  Panel: {
    collapse: 'Collapse',
    expand: 'Expand'
  },
  Pagination: {
    totalShort: '/%%total%%',
    itemsPerPage: 'Kohdetta per sivu',
    all: 'Kaikki',
    total: 'Sivu %%current%%/%%total%%'
  },
  Popover: {
    closeButton: 'Close'
  },
  ProgressDialog: {
    closeButton: 'Sulje',
    cancelButton: 'Peruuta'
  },
  Section: {
    collapse: 'Collapse',
    closeButton: 'Close',
    expand: 'Expand'
  },
  Select: {
    clearButton: 'Clear',
    noOptions: 'Ei vaihtoehtoja',
    placeholder: 'Valitse...'
  },
  SearchBar: {
    clearButton: 'Clear',
    searchButton: 'Search',
    collapseSearch: 'Hide search input',
    expandSearch: 'Show search input'
  },
  SpotPopup: {
    total: '%%current%%/%%total%%'
  },
  SwitchesPanelItem: {
    showDescription: 'Show description'
  },
  Tabs: {
    closeButton: 'Close tab'
  },
  Toaster: {
    closeGroup: 'Sulje ryhmä'
  },
  Toast: {
    closeButton: 'Close'
  }
};